// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "05d12160492fd6ec2544" + ".js";
};